/** The unit-count copy beside a holding: the compact "Qty: N" text plus its spoken form. A screen
 * reader voices the abbreviation literally, so every "Qty:" figure uses `a11y` as its
 * `accessibilityLabel`. The KPI tiles and the top-positions rows share this so both strings match.
 *
 * `count` may be negative (TRO-233): oversell debt from a Channel double-sale (TRO-224, TRO-241)
 * means the shop owes a copy. A bare "Qty: -1" reads as a data error, so a negative count gets
 * "Owed" wording, never just the sign. */
export function qtyLabel(count: number): { text: string; a11y: string; } {
  if (count < 0) return owedLabel(count);
  return {
    text: `Qty: ${count}`,
    a11y: `${count} ${count === 1 ? "unit" : "units"}`,
  };
}

/** The oversell-debt copy on its own, for call sites that render the owed state without "Qty:",
 * such as the owed badge, the card-detail quantity row and the stock row and grid accessibility
 * labels. This is the only source of that wording, so a debt reads and sounds the same everywhere;
 * `qtyLabel` returns it for a negative count. `count` is the signed raw qty; this takes the
 * magnitude. */
export function owedLabel(count: number): { text: string; a11y: string; } {
  const owed = Math.abs(count);
  return {
    text: `Owed ×${owed}`,
    a11y: `owed ${owed} ${owed === 1 ? "unit" : "units"}`,
  };
}
